<template>
  <v-card class="mb-4">
    <v-card-title class="text-subtitle-1 d-flex align-center">
      <v-icon icon="mdi-information-outline" start size="small"/>
      Filter-Syntax
      <v-spacer/>
      <v-btn
          icon="mdi-close"
          variant="text"
          size="small"
          @click="$emit('close')"
      />
    </v-card-title>
    <v-divider/>
    <v-card-text class="text-body-2">
      <v-row dense>
        <v-col cols="12" md="6">
          <div class="mb-2"><strong>Vergleiche:</strong></div>
          <div class="filter-example">
            <code>>100</code> - Größer als 100
          </div>
          <div class="filter-example">
            <code>>=100</code> - Größer oder gleich 100
          </div>
          <div class="filter-example">
            <code>&lt;100</code> - Kleiner als 100
          </div>
          <div class="filter-example">
            <code>&lt;=100</code> - Kleiner oder gleich 100
          </div>
          <div class="filter-example">
            <code>10..50</code> - Zwischen 10 und 50
          </div>
        </v-col>

        <v-col cols="12" md="6">
          <div class="mb-2"><strong>Text-Filter:</strong></div>
          <div class="filter-example">
            <code>motor</code> - Enthält "motor"
          </div>
          <div class="filter-example">
            <code>*motor*</code> - Enthält "motor" (explizit)
          </div>
          <div class="filter-example">
            <code>motor*</code> - Beginnt mit "motor"
          </div>
          <div class="filter-example">
            <code>*350</code> - Endet mit "350"
          </div>
          <div class="filter-example">
            <code>!=BEEND</code> - Nicht "BEEND"
          </div>
          <div class="filter-example">
            <code>TDE,TDM</code> - Ist "TDE" oder "TDM"
          </div>
          <div class="filter-example">
            <code>!TDE,TDM,PROD</code> - Ist Alles außer  "TDE", "TDM" und "PROD"
          </div>
        </v-col>
      </v-row>
    </v-card-text>
  </v-card>
</template>

<script setup lang="ts">
defineEmits(['close'])
</script>

<style scoped>
.filter-example {
  padding: 4px 0;
  font-size: 0.875rem;
}

code {
  background-color: rgba(var(--v-theme-primary), 0.1);
  padding: 2px 6px;
  border-radius: 3px;
  font-family: 'Courier New', monospace;
  color: rgb(var(--v-theme-primary));
  font-weight: 600;
}
</style>